import Navbar from '../../components/layout/Navbar';
import Configuracion from '../../components/sections/Configuracion';
import Footer from '../../components/layout/Footer';

export default function ConfiguracionPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar activeSection="configuracion" />

      <main className="pt-16">
        <Configuracion />
      </main>

      <Footer />
    </div>
  );
}